import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 21H1V3H23V21ZM5 8V11.4004L4.93164 11.4375L5 11.5645V12.4346L4.93164 12.5625L5 12.5986V16H7V13.6689L9 14.7412V16H11V14.2529C10.9999 13.724 10.6634 13.3638 10.3525 13.1973L8.11719 12L10.3525 10.8027C10.6634 10.6362 10.9999 10.2759 11 9.74707V8H9V9.25781L7 10.3301V8H5ZM13 16H15V13.3066L17 14.8486V16H19V14.4561C18.9998 14.0628 18.809 13.7181 18.5273 13.501L17.8271 12.9609C18.3182 12.8372 18.7645 12.416 18.7646 11.7861V9.21387C18.7644 8.50468 18.1992 8.0578 17.6406 8.00488L17.5293 8H13V16ZM16.7646 11H15V10H16.7646V11Z"}}]};

const KoreanRectangleFilled = Vue.extend<IconProps>({
  name: 'KoreanRectangleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'korean-rectangle-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default KoreanRectangleFilled;
